export default __webpack_public_path__ + "static/media/Osqledaren1.8db24ef1.png";